<template>
  <div class="w-full h-64">
    <div class="h-full w-full" ref="map"></div>
  </div>
</template>

<script>
export default {
  name: "MapEmbed",
  props: {
    lat: {
      required: true,
      type: Number
    },
    long: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      map: null,
      marker: null
    };
  },
  mounted() {
    this.map = new window.google.maps.Map(this.$refs.map, {
      center: { lat: this.lat, lng: this.long },
      zoom: 16
    });
    this.marker = new window.google.maps.Marker({
      position: { lat: this.lat, lng: this.long },
      map: this.map
    });
  }
};
</script>

<style>
</style>